import {Keycode} from "../constants";

export const Lightbox = {
	/** 
	 * constructor
	 * */
	_inputContent: null,
	_lightbox: null,
	_wrapper: null,
	_content: null,
	_lightboxHandler: null,
	_scrollPosition: null,
	_closeCallback: null,
	_lightboxClasses: null,
	_onCloseAction: null,
	/** */
	
	/** 
	 * public
	 * */
	open( content, onCloseAction, ...classes ) {
		if ( this._lightbox )
		{
			this.close();
		}
		
		this._inputContent = content.outerHTML || content;
		this._lightboxClasses = classes;
		this._onCloseAction = onCloseAction;
		this._rememberScrollPosition();
		this._showLightbox();
		this._setPageStyles();
		// this._initTouch(); // mobile close by swap

		this._lightbox.classList.add(`lightbox--show`);
	},

	close() {
		const transitionDuration = parseFloat(window.getComputedStyle(this.getLightbox(),null).getPropertyValue(`transition-duration`));

		this._lightbox.classList.remove(`lightbox--show`);

		if ( this._onCloseAction )
		{
			this._onCloseAction();
		}
		
		setTimeout(() => {
			this._removeLightbox();
			this._removePageStyles();
			this._clearHash();
			this._setScrollPosition();

			if ( this._closeCallback )
			{
				this._closeCallback();
			}
		}, transitionDuration * 1000 );
	},

	addCloseCallback( callback )
	{
		this._closeCallback = callback;
	},

	getLightbox()
	{
		return this._lightbox;
	},

	addClasses(element, ...className)
	{
		const node = this._getElementNode(element);

		if (node)
		{
			node.classList.add(...className);
		}
	},

	removeClasses(element, ...className)
	{
		const node = this._getElementNode(element);

		if (node)
		{
			node.classList.remove(...className);
		}
	},

	addAttribute(element, attributeName, value)
	{
		const node = this._getElementNode(element);

		if (node)
		{
			node.setAttribute(attributeName, value);
		}
	},

	removeAttribute(element, attributeName)
	{
		const node = this._getElementNode(element);

		if (node)
		{
			node.removeAttribute(attributeName);
		}
	},

	appendContent(content)
	{
		if (this._content)
		{
			this._inputContent += content;
			this._content.insertAdjacentHTML(`beforeend`, content);
		}
	},

	replaceContent(content)
	{
		if (this._content)
		{
			this._inputContent = content;
			this._content.innerHTML = this._inputContent;
		}
	},
	/** */
	
	/** 
	 * private
	 * */
	_getElementNode(value)
	{
		return value === `lightbox` ? this._lightbox : value === `wrapper` ? this._wrapper : this._content;
	},

	_showLightbox()
	{
		this._createLightbox();
		this._setLightboxHandlers();
	},

	_createLightbox()
	{
		this._lightbox = document.createElement(`div`);
		this._lightbox.classList.add(`lightbox`);
		
		if ( this._lightboxClasses[0] )
		{
			this._lightbox.classList.add( this._lightboxClasses );
		}
		
		this._createContent();
		this._lightbox.appendChild(this._wrapper);
		document.body.appendChild(this._lightbox);
	},

	_createContent()
	{
		this._wrapper = document.createElement(`div`);
		this._wrapper.classList.add(`wrapper`);
		this._createCloseButton();

		this._content = document.createElement(`div`);
		this._content.classList.add(`content`);
		this._content.innerHTML = this._inputContent;

		this._wrapper.appendChild(this._content);
	},

	_createCloseButton()
	{
        const lang = document.querySelector('body').classList.contains('en') ? 'en' : 'ru';
		const closeButton = document.createElement(`button`);
		closeButton.type = `button`;
		closeButton.classList.add(`close`);
		closeButton.textContent = (lang == 'en') ? `Close` : `Закрыть`;
		this._wrapper.prepend(closeButton);
	},

	_setLightboxHandlers()
	{
		const action = this.close.bind(this);

		const makeCloseLightbox = () => ((evt) => {
			if (
				evt.keyCode === Keycode.ESC
				||
				( evt.target.tagName.toLowerCase() === `button` && evt.target.classList.contains(`close`) )
				||
				( evt.target.tagName.toLowerCase() === `div` && evt.target.classList.contains( `lightbox` ) )
			) {
				action();
			}
		});

		this._lightboxHandler = makeCloseLightbox();

		document.addEventListener(`keyup`, this._lightboxHandler);
		document.addEventListener(`click`, this._lightboxHandler);
	},

	_removeLightboxHandlers()
	{
		document.removeEventListener(`keyup`, this._lightboxHandler);
		document.removeEventListener(`click`, this._lightboxHandler);
		this._lightboxHandler = null;
	},

	_setPageStyles()
	{
		document.documentElement.style.paddingRight = `${this._getScrollWidth()}px`;
		document.documentElement.style.overflow = `hidden`;
		document.body.style.overflow = `hidden`;

		document.body.classList.add(`lightbox`);
	},

	_removePageStyles()
	{
		if ( !document.body.classList.contains(`show-menu`) )
		{
			document.documentElement.style.paddingRight = ``;
			document.documentElement.style.overflow = ``;
			document.body.style.overflow = ``;
		}

		document.body.classList.remove(`lightbox`);
	},

	_getScrollWidth()
	{
		return window.innerWidth - document.body.clientWidth;
	},

	_rememberScrollPosition()
	{
		this._scrollPosition = [window.pageXOffset, window.pageYOffset];
	},

	_clearHash()
	{
		if ( location.hash )
		{
			location.hash = ``;
		}
	},

	_setScrollPosition()
	{
		window.scrollTo(...this._scrollPosition);
		this._scrollPosition = null;
	},

	_removeLightbox()
	{
		this._lightbox.remove();
		this._inputContent = null;
		this._lightbox = null;
		this._contentOutput = null;
		this._wrapper = null;
		this._content= null;
		this._removeLightboxHandlers();
	},

	_initTouch() {
		const contentWrapper = this.getLightbox().querySelector(`div.wrapper`);
		let wasStarted = false;
		let isDetecting = false;
		let startX;
		let moveX;
		let prevShiftY;
		let shiftY;
		let startY;
		let moveY;
		
		const moveWrapper = ( moveEvt ) => {
			if ( !wasStarted && !isDetecting )
			{
				return;
			}

			moveX = moveEvt.touches[0].clientX;
			moveY = moveEvt.touches[0].clientY;

			if ( isDetecting )
			{
				if ( Math.abs(startX - moveX) <= Math.abs(startY - moveY) )
				{
					moveEvt.preventDefault();

					wasStarted = true;
				}

				isDetecting = false;
			}

			if ( wasStarted )
			{
				moveEvt.preventDefault();

				prevShiftY = shiftY;
				shiftY = (moveY - startY) * 100 / contentWrapper.offsetHeight;
				contentWrapper.style.transition = `none`;
				contentWrapper.style.transform = `translateY(${shiftY < 0 ? 0 : shiftY}%)`;
			}
		};

		const endMoveWrapper = ( endEvt ) => {
			if ( !wasStarted || isDetecting )
			{
				return isDetecting = false;
			}

			endEvt.preventDefault();
			wasStarted = false;

			contentWrapper.style.transition = ``;

			if ( prevShiftY < shiftY )
			{
				contentWrapper.style.transform = `translateY(100%)`;
				this.close();
			} else
			{
				contentWrapper.style.transform = ``;
			}
		};

		this.addCloseCallback( () => {
			document.removeEventListener(`touchmove`, moveWrapper);
			document.removeEventListener(`touchend`, endMoveWrapper);
		});
		
		contentWrapper.addEventListener(`touchstart`, ( startEvt ) => {
			if ( wasStarted )
			{
				return;
			}

			isDetecting = true;

			startX = startEvt.touches[0].clientX;
			startY = startEvt.touches[0].clientY;
		});
		document.addEventListener(`touchmove`, moveWrapper, {passive: false});
		document.addEventListener(`touchend`, endMoveWrapper, {passive: false});
	},

	/** */
};
